export function mediaUrl(path) {
  return path || null
}
